export const NOTIFICATION_CHANGED = 'NOTIFICATION_CHANGED'

export const FC_QUOTA_WARNING_SIZE        = 1048576 // 10MB
export const S3_DIRECT_QUOTA_WARNING_SIZE = 1048576 // 10MB

export const on_top_notification_changed = (message, on_click, button_text, notification_type) => ({
  type : NOTIFICATION_CHANGED,
  message, button_text, notification_type, on_click
})
